import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme as sharedTheme } from "shared/lib/styles";

import { Figure, StyledFigcaption } from "scmp-app/components/content/content-cover-image/styles";
import {
  H2Container as ContentSubHeadlineH2Container,
  H3Container as ContentSubHeadlineH3Container,
} from "scmp-app/components/content/content-sub-headline/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: grid;
  grid:
    "cover-image" min-content
    "content" min-content
    / minmax(0, 1fr);

  inline-size: 100%;

  color: #000000;
  ${sharedTheme.breakpoints.up("tablet")} {
    grid:
      "content" min-content
      "cover-image" min-content
      "sub-content" min-content
      / minmax(0, 1fr);
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    grid: "cover-image content" min-content / min-content minmax(0, 1fr);
  }
`;

export const Content = styled.div`
  grid-area: content;

  ${sharedTheme.breakpoints.up("tablet")} {
    margin-block-end: 20px;
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    margin-block-end: 0;
  }
`;

export const StyledEntityLink = styled(EntityLink)``;

export const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Headline = styled.div`
  margin-block-end: 0;

  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 25.2px;

  ${sharedTheme.breakpoints.up("tablet")} {
    font-size: 22px;
    line-height: 30.8px;
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    margin-block-end: 8px;
  }
`;

export const LiveTagContainer = styled.div`
  margin-block-end: 8px;

  :empty {
    margin-block-end: 0;
  }
`;

export const SubHeadline = styled.div`
  display: none;
  ${sharedTheme.breakpoints.up("desktop")} {
    display: block;

    color: #6f6f6f;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 18.2px;
  }

  ${ContentSubHeadlineH2Container}, ${ContentSubHeadlineH3Container} {
    li + li {
      margin-block-start: 12px;
    }
  }
`;

export const ActionBar = styled.div`
  margin-block-start: 12px;
  time {
    color: #999999;
    font-size: 12px;
    line-height: 14px;
  }
`;

export const CoverImage = styled.div`
  grid-area: cover-image;

  block-size: auto;
  margin-block-end: 12px;
  margin-inline: -20px;
  ${Figure} picture {
    aspect-ratio: 3/2;

    img {
      aspect-ratio: inherit;
    }
  }

  ${StyledFigcaption} {
    display: none;

    ${sharedTheme.breakpoints.up("tablet")} {
      display: block;

      line-height: 14px;
    }
  }
  ${sharedTheme.breakpoints.up("tablet")} {
    margin-block-end: 0;
    margin-inline: 0;
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    inline-size: 336px;
    margin-inline-end: 24px;
  }
`;

const SubContentStyle = css`
  margin-block-start: 20px;
  padding-block-start: 20px;
  border-block-start: 1px solid rgba(0, 0, 0, 0.1);
`;

export const SubContentInMobileAndDesktop = styled.div`
  ${sharedTheme.breakpoints.up("tablet")} {
    display: none;
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    display: block;
    ${SubContentStyle};
  }
`;

export const SubContentInTablet = styled.div`
  grid-area: sub-content;

  ${SubContentStyle};
  display: none;
  ${sharedTheme.breakpoints.up("tablet")} {
    display: block;
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    display: none;
  }
`;
